<template>
<el-dialog :visible="visible" :title="'Seleccione al ' + title + ' que participará'" @open="onOpened" @close="onClose" @closed="onClosed" top="5vh" width="800px">
    <template #title>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="mb-0">{{title}}</h3>
            <div class="d-flex align-items-center position-relative mr-8">
                <div class="input-icon input-group-sm">
                    <input type="text" v-model="search" class="form-control input-sm" placeholder="Buscar..." maxlength="30">
                    <span><i class="fas fa-search text-muted"></i></span>
                </div>
            </div>
        </div>
    </template>
    <SelectionPerson :list="filterData" @getSelection="getSelection"></SelectionPerson>
</el-dialog>
</template>

<script>
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

import code from "@/core/config/error";

//services
import payrollService from "@/core/services/payroll.service"

//components
import SelectionPerson from "@/components/SelectionPerson"

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
            default: "",
        },
        record_type: {
            type: String,
            required: true,
            default: "",
        }
    },
    data: () => ({
        search: '',
        lista: []
    }),
    components: {
        SelectionPerson,
    },
    computed: {
        filterData: function () {
            return this.lista.filter(data => !this.search || data.personName.toLowerCase().includes(this.search.toLowerCase()))
        }
    },
    methods: {
        onClose() {
            this.$emit("update:visible", false);
        },
        onClosed() {
            this.lista = [];
        },
        onOpened() {
            this.getLista()
        },
        async getLista() {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await payrollService.getData({
                record_type: this.record_type
            }).then((res) => {
                this.lista = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(error.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        getSelection(data) {
            this.$emit("openDialogRegister", data)
        }
    }

}
</script>
